import React from "react";
import EventGroupList from "../../components/event/EventGroupList";

const EventGroupsPage = () => {
    return <EventGroupList/>
}

export default EventGroupsPage;